module.exports = __webpack_public_path__ + "static/img/4.4b8cbec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/4.jpg
// module id = Qo2b
// module chunks = 1